import './HomeBanner.css';
import { useState, useEffect } from 'react';
import desktopBanner from "../assets/jyotish-karmaa-banner-1.png";
import mobileBanner from "../assets/jyotish-karmaa-mobile.png";
import { Link } from 'react-router-dom';
import { FaArrowDown } from "react-icons/fa";

function HomeBanner() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      className="hero-banner"
      style={{
        backgroundImage: `url(${isMobile ? mobileBanner : desktopBanner})`
      }}
    >
      <div className="hero-content">
        <h1 className="welcome-text">कुंडली से जानें अपनी असली पहचान</h1>
        <p className="description">
          शांति, सफलता और सुख के लिए सटीक कुंडली भविष्यवाणी
        </p>
         <div className="animated-arrow-home">
            <FaArrowDown />
          </div>
        <Link to="/contact" className="hero-btn">Get My Kundli</Link>
      </div>
    </section>
  );
}

export default HomeBanner;
